import { connect } from 'react-redux';
import { State } from 'store/types';
import View from './View';


const mapStateToProps = (state: State) => {
  const { footer, appReducer } = state;
  return {
    aboutUs: footer?.aboutUs,
    pageType: appReducer?.pageType,
  };
};

export default connect(mapStateToProps)(View);
